export class Flyout {
	constructor( node, opts ) {
		this.node = node;
		this.opts = {
			open: '.flyout-button a',
			close: '.flyout-menu__close',
			...opts,
		};

		this.classes = {
			open: 'flyout-menu--open',
			activeOverlay: 'has-active-overlay',
		};

		if ( ! this.node ) {
			return;
		}

		this.openBtn = document.querySelector( this.opts.open );
		this.closeBtn = this.node.querySelector( this.opts.close );

		if ( this.openBtn ) {
			this.openBtn.addEventListener( 'click', ( e ) => this.open( e ) );
		} else {
			console.error( 'Open button not found' );
		}

		if ( this.closeBtn ) {
			this.closeBtn.addEventListener( 'click', () => this.close() );
		} else {
			console.error( 'Close button not found' );
		}

		document.addEventListener( 'keydown', ( e ) => this.handleKeydown( e ) );
	}

	open( e ) {
		if ( window.innerWidth >= 992 ) {
			e.preventDefault();
		}

		this.node.classList.add( this.classes.open );
		document.documentElement.classList.add( this.classes.activeOverlay );
	}

	close() {
		this.node.classList.remove( this.classes.open );
		document.documentElement.classList.remove( this.classes.activeOverlay );
	}

	handleKeydown( e ) {
		if ( e.key === 'Escape' || e.key === 'Esc' ) {
			this.close();
		}
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const node = document.querySelector( '.flyout-menu' );
	if ( node ) {
		new Flyout( node, { ...node.dataset } );
	}
} );
